import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useCostTypesApi } from "../../../http/costTypes/api";
import ModalDialog from "../../ui/ModalDialog";

interface DeleteCostTypeDialogProps {
  costTypeId: string;
  onClose: () => void;
}

const DeleteCostTypeDialog: FC<DeleteCostTypeDialogProps> = ({ onClose, costTypeId }) => {
  const i18n = useI18n();
  const costTypesApi = useCostTypesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.costTypes.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            costTypesApi
              .deleteAdminCostType(costTypeId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.costTypes.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCostTypeDialog;
